import CityPageTemplate from "../city-template/CityPageTemplate";
import { ogunquitConfig } from "./data";

export default function OgunquitPage() {
  return <CityPageTemplate config={ogunquitConfig} />;
}